<p>
  {{data.message}}
</p>
<i class="iq-icon--remove iq-clickable-icon" (click)="onClose();"></i>